module.exports = __webpack_public_path__ + "img/Mob_Slider2.e85441fb.svg";